import { ModelLockBanner } from "@components/ui-kit/model-lock-banner";
import { t } from "@lingui/macro";
import { can } from "@src/utils/components/permissions";
import { observer } from "mobx-react-lite";
import React from "react";
import { InvoiceTypeEnum, useInvoiceStore } from "../../store";
import AlreadyInvoicedFilter from "./AlreadyInvoicedFilter";
import { OldInvoiceBanner } from "./OldInvoiceBanner";
import OnlyInvoicedFilter from "./OnlyInvoicedFilter";
import { ProjectOverdueBanner } from "./ProjectOverdueBanner";

export const Header = observer(function Header() {
  const store = useInvoiceStore();

  return (
    <React.Fragment>
      <div className="flex justify-end items-center">
        {store.currentStep.id === store.steps[1].id && (
          <label className="mb-12" htmlFor="invoiced-filter">
            {store.isRFI ? (
              <AlreadyInvoicedFilter
                checked={store.hideAlreadyInvoiced}
                onToggle={store.toggleHideAlreadyInvoiced}
              />
            ) : (
              <OnlyInvoicedFilter
                checked={store.showOnlyChecked}
                onToggle={store.toggleShowOnlyChecked}
              />
            )}
          </label>
        )}
      </div>
      {store.currentStep.id !== store.steps[0].id && store.projectOverdue && (
        <ProjectOverdueBanner projectOverdue={store.projectOverdue} />
      )}
      {store.old_invoice_alert && (
        <OldInvoiceBanner date={store.form.date_of_supply.$} />
      )}
      <ModelLockBanner
        mb="6"
        show={store.isLocked}
        loading={store.isUnlocking}
        onClick={store.unlock}
        canUnlock={can("outgoingInvoice_modelLock")}
        model={
          store.type === InvoiceTypeEnum.Proforma
            ? t`proforma invoice`
            : store.type === InvoiceTypeEnum.Outgoing
              ? t`outgoing invoice`
              : t`invoice`
        }
      />
    </React.Fragment>
  );
});
